<template>
  <router-view />
</template>

<script>
import { Table } from '@/store/models'

export default {
  name: 'Establishments',
  mounted () {
    Table.api().get()
  }
}
</script>

<style scoped>

</style>
